/** Processor id for message-thread Q&A (@ note in message list). */
export const CHAT_MESSAGE_QUERY_PROCESSOR_ID = 'chat-message-query';
